(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 39851:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30257);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ BackgroundCircle_BackgroundCircle; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/BackgroundCircle/BackgroundCircle.module.scss
var BackgroundCircle_module = __webpack_require__(15450);
var BackgroundCircle_module_default = /*#__PURE__*/__webpack_require__.n(BackgroundCircle_module);
;// CONCATENATED MODULE: ./components/BackgroundCircle/BackgroundCircle.tsx




var BackgroundCircle = function(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom, width = param.width, height = param.height, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style, _animation = param.animation, animation = _animation === void 0 ? "none" : _animation, _animationDuration = param.animationDuration, animationDuration = _animationDuration === void 0 ? "3s" : _animationDuration, _animationDelay = param.animationDelay, animationDelay = _animationDelay === void 0 ? "0s" : _animationDelay;
    var positionStyle = (0,_object_spread/* default */.Z)({
        position: "absolute",
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: width,
        height: height,
        zIndex: -1,
        pointerEvents: "none"
    }, style);
    var animationStyle = {
        animationDuration: animationDuration,
        animationDelay: animationDelay
    };
    var classes = [
        (BackgroundCircle_module_default()).backgroundCircle,
        animation !== "none" && (BackgroundCircle_module_default())["animation-".concat(animation)],
        className, 
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        style: (0,_object_spread/* default */.Z)({}, positionStyle, animationStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/background-circles/desktop-circle.svg",
                alt: "",
                "aria-hidden": "true",
                loading: "lazy",
                className: (BackgroundCircle_module_default()).desktopCircle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/background-circles/tablet-circle.svg",
                alt: "",
                "aria-hidden": "true",
                loading: "lazy",
                className: (BackgroundCircle_module_default()).tabletCircle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/background-circles/mobile-circle.svg",
                alt: "",
                "aria-hidden": "true",
                loading: "lazy",
                className: (BackgroundCircle_module_default()).mobileCircle
            })
        ]
    });
};
/* harmony default export */ var BackgroundCircle_BackgroundCircle = (BackgroundCircle);

;// CONCATENATED MODULE: ./components/BackgroundCircle/index.ts



/***/ }),

/***/ 62874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/Checkbox/Checkbox.module.scss
var Checkbox_module = __webpack_require__(46641);
var Checkbox_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_module);
;// CONCATENATED MODULE: ./components/Checkbox/Checkbox.tsx







var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var label = _param.label, checked = _param.checked, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, onChange = _param.onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "md" : _size, _color = _param.color, color = _color === void 0 ? "primary" : _color, _className = _param.className, className = _className === void 0 ? "" : _className, _labelClassName = _param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "checked",
        "defaultChecked",
        "onChange",
        "disabled",
        "size",
        "color",
        "className",
        "labelClassName",
        "error"
    ]);
    var _$ref = (0,react.useState)(defaultChecked), isChecked = _$ref[0], setIsChecked = _$ref[1];
    var _$ref1 = (0,react.useState)(false), isFocused = _$ref1[0], setIsFocused = _$ref1[1];
    // Stable across server/client render (unlike Math.random(), which caused
    // a hydration mismatch and, since it was called separately for the input
    // and the label, didn't even match its own htmlFor within one render).
    var generatedId = (0,react.useId)();
    var inputId = props.id || "checkbox-".concat(generatedId);
    var currentChecked = checked !== undefined ? checked : isChecked;
    var handleChange = function(e) {
        var newChecked = e.target.checked;
        if (checked === undefined) {
            setIsChecked(newChecked);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newChecked);
    };
    var handleFocus = function() {
        setIsFocused(true);
    };
    var handleBlur = function() {
        setIsFocused(false);
    };
    var checkboxClasses = [
        (Checkbox_module_default()).checkbox,
        (Checkbox_module_default())["size-".concat(size)],
        (Checkbox_module_default())["color-".concat(color)],
        currentChecked && (Checkbox_module_default()).checked,
        disabled && (Checkbox_module_default()).disabled,
        isFocused && (Checkbox_module_default()).focused,
        error && (Checkbox_module_default()).error,
        className, 
    ].filter(Boolean).join(" ");
    var labelClasses = [
        (Checkbox_module_default()).label,
        disabled && (Checkbox_module_default()).labelDisabled,
        error && (Checkbox_module_default()).labelError,
        labelClassName, 
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Checkbox_module_default()).checkboxContainer, " ").concat(error ? (Checkbox_module_default()).error : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: checkboxClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: ref,
                        type: "checkbox",
                        checked: currentChecked,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        disabled: disabled,
                        className: (Checkbox_module_default()).input
                    }, props), {
                        id: inputId
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Checkbox_module_default()).checkboxBox,
                        style: error ? {
                            borderColor: "var(--color-error)"
                        } : {},
                        children: currentChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: (Checkbox_module_default()).checkmark,
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10 3L4.5 8.5L2 6",
                                stroke: "#FFFFFF",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: inputId,
                className: labelClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    as: "span",
                    color: disabled ? "disabled" : error ? "error" : "secondary",
                    weight: "normal",
                    children: label
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/Checkbox/index.ts



/***/ }),

/***/ 55306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cv": function() { return /* reexport */ StructuredData_ArticleSchema; },
  "vd": function() { return /* reexport */ StructuredData_BreadcrumbSchema; },
  "od": function() { return /* reexport */ StructuredData_OrganizationSchema; },
  "zC": function() { return /* reexport */ StructuredData_ProductSchema; },
  "uA": function() { return /* reexport */ StructuredData_SoftwareApplicationSchema; }
});

// UNUSED EXPORTS: StructuredData

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/head.js
var head = __webpack_require__(73917);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/StructuredData/StructuredData.tsx


var StructuredData = function(param) {
    var data = param.data;
    var jsonLd = Array.isArray(data) ? data : [
        data
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: jsonLd.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // JSON.stringify doesn't escape "</script>" - a field containing
                // that literal string could break out of the script tag and
                // inject arbitrary markup/script into the page.
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(item).replace(/</g, "\\u003c")
                }
            }, index);
        })
    });
};
/* harmony default export */ var StructuredData_StructuredData = (StructuredData);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
;// CONCATENATED MODULE: ./components/StructuredData/OrganizationSchema.tsx
/* provided dependency */ var process = __webpack_require__(82985);



var OrganizationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "EPEN Ltd." : _name, _url = param.url, url = _url === void 0 ? "https://vxfx.io" : _url, _logo = param.logo, logo = _logo === void 0 ? "https://vxfx.io/epenfav.webp" : _logo, _description = param.description, description = _description === void 0 ? "EPEN Ltd. is a software company that develops video plugin development frameworks for Adobe Premiere and DaVinci Resolve." : _description, email = param.email, phone = param.phone, address = param.address, _sameAs = param.sameAs, sameAs = _sameAs === void 0 ? [] : _sameAs;
    var siteUrl = process.env.SITE_URL || "https://vxfx.io";
    var organizationSchema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: name,
        url: url || siteUrl,
        logo: logo || "".concat(siteUrl, "/epenfav.webp"),
        description: description
    }, email && {
        email: email
    }, phone && {
        telephone: phone
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address.streetAddress && {
            streetAddress: address.streetAddress
        }, address.addressLocality && {
            addressLocality: address.addressLocality
        }, address.addressRegion && {
            addressRegion: address.addressRegion
        }, address.postalCode && {
            postalCode: address.postalCode
        }, address.addressCountry && {
            addressCountry: address.addressCountry
        })
    }, sameAs.length > 0 && {
        sameAs: sameAs
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: organizationSchema
    });
};
/* harmony default export */ var StructuredData_OrganizationSchema = (OrganizationSchema);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
;// CONCATENATED MODULE: ./components/StructuredData/ProductSchema.tsx
/* provided dependency */ var ProductSchema_process = __webpack_require__(82985);




var ProductSchema = function(param) {
    var name = param.name, description = param.description, image = param.image, url = param.url, _brand = param.brand, brand = _brand === void 0 ? "EPEN Ltd." : _brand, sku = param.sku, offers = param.offers, aggregateRating = param.aggregateRating;
    var siteUrl = ProductSchema_process.env.SITE_URL || "https://vxfx.io";
    var productUrl = url || "".concat(siteUrl, "/video-plugin-framework/").concat(name.toLowerCase().replace(/\s+/g, "-"));
    var productImage = image || "".concat(siteUrl, "/epenfav.webp");
    var productSchema = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Product",
        name: name
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            productImage
        ],
        url: productUrl,
        brand: {
            "@type": "Brand",
            name: brand
        }
    }), sku && {
        sku: sku
    }, offers && {
        offers: (0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }, offers.priceCurrency && {
            priceCurrency: offers.priceCurrency
        }, offers.availability && {
            availability: "https://schema.org/".concat(offers.availability)
        }, offers.url && {
            url: offers.url
        })
    }, aggregateRating && {
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: aggregateRating.ratingValue,
            reviewCount: aggregateRating.reviewCount
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: productSchema
    });
};
/* harmony default export */ var StructuredData_ProductSchema = (ProductSchema);

;// CONCATENATED MODULE: ./components/StructuredData/ArticleSchema.tsx
/* provided dependency */ var ArticleSchema_process = __webpack_require__(82985);




var ArticleSchema = function(param) {
    var headline = param.headline, description = param.description, image = param.image, datePublished = param.datePublished, dateModified = param.dateModified, author = param.author, _publisher = param.publisher, publisher = _publisher === void 0 ? {
        name: "EPEN Ltd.",
        logo: "https://vxfx.io/epenfav.webp"
    } : _publisher, url = param.url;
    var siteUrl = ArticleSchema_process.env.SITE_URL || "https://vxfx.io";
    var articleUrl = url || "".concat(siteUrl, "/news/").concat(headline.toLowerCase().replace(/\s+/g, "-"));
    var articleImage = image || "".concat(siteUrl, "/epenfav.webp");
    var articleSchema = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: headline
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            articleImage
        ],
        datePublished: datePublished
    }), dateModified && {
        dateModified: dateModified
    }, author && {
        author: (0,_object_spread/* default */.Z)({
            "@type": "Person",
            name: author.name
        }, author.url && {
            url: author.url
        })
    }), {
        publisher: {
            "@type": "Organization",
            name: publisher.name,
            logo: {
                "@type": "ImageObject",
                url: publisher.logo || "".concat(siteUrl, "/epenfav.webp")
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": articleUrl
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: articleSchema
    });
};
/* harmony default export */ var StructuredData_ArticleSchema = (ArticleSchema);

;// CONCATENATED MODULE: ./components/StructuredData/BreadcrumbSchema.tsx
/* provided dependency */ var BreadcrumbSchema_process = __webpack_require__(82985);


var BreadcrumbSchema = function(param) {
    var items = param.items;
    var siteUrl = BreadcrumbSchema_process.env.SITE_URL || "https://vxfx.io";
    var breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: item.name,
                item: item.url.startsWith("http") ? item.url : "".concat(siteUrl).concat(item.url)
            };
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: breadcrumbSchema
    });
};
/* harmony default export */ var StructuredData_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/StructuredData/SoftwareApplicationSchema.tsx
/* provided dependency */ var SoftwareApplicationSchema_process = __webpack_require__(82985);




var SoftwareApplicationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "VxFx" : _name, _description = param.description, description = _description === void 0 ? "Universal video plugin framework supporting Windows, macOS, and Linux. GPU-accelerated with CUDA, OpenCL, Metal, and DirectX." : _description, image = param.image, _operatingSystem = param.operatingSystem, operatingSystem = _operatingSystem === void 0 ? "Windows, macOS, Linux" : _operatingSystem, _applicationCategory = param.applicationCategory, applicationCategory = _applicationCategory === void 0 ? "MultimediaApplication" : _applicationCategory, offers = param.offers;
    var siteUrl = SoftwareApplicationSchema_process.env.SITE_URL || "https://vxfx.io";
    var schema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: name,
        description: description,
        image: image || "".concat(siteUrl, "/epenfav.webp"),
        operatingSystem: operatingSystem,
        applicationCategory: applicationCategory,
        url: siteUrl
    }, offers && {
        offers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }), {
            priceCurrency: offers.priceCurrency || "USD"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: schema
    });
};
/* harmony default export */ var StructuredData_SoftwareApplicationSchema = (SoftwareApplicationSchema);

;// CONCATENATED MODULE: ./components/StructuredData/index.ts








/***/ }),

/***/ 15516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _TextInput__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5166);
/* harmony import */ var _PhoneNumberInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96338);




/***/ }),

/***/ 77585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(21470)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(5506)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var _loadable = _interop_require_default(__webpack_require__(67483));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 383:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 67483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(31358)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(56993)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(5506)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(57022)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(50959));
var _loadableContext = __webpack_require__(383);
var useSyncExternalStore = ( true ? __webpack_require__(50959) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 30257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/dynamic.js
var dynamic = __webpack_require__(55716);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(15767);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/image.js
var next_image = __webpack_require__(26538);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/formik@2.4.9_@types+react@18.0.21_react@18.2.0/node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(99415);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@1.7.1/node_modules/yup/index.esm.js
var index_esm = __webpack_require__(70119);
// EXTERNAL MODULE: ./components/Connects/connects.module.scss
var connects_module = __webpack_require__(99481);
var connects_module_default = /*#__PURE__*/__webpack_require__.n(connects_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@1.18.1_debug@4.4.3_supports-color@7.2.0__supports-color@7.2.0/node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(81944);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(57337);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/router.js
var router = __webpack_require__(96376);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(32033);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-awesome-reveal@4.3.1_@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_sup_9ec67bc2838b979fc11a3db5ae856235/node_modules/react-awesome-reveal/dist/index.js + 2 modules
var react_awesome_reveal_dist = __webpack_require__(56399);
// EXTERNAL MODULE: ./components/BackgroundCircle/index.ts + 1 modules
var BackgroundCircle = __webpack_require__(22462);
// EXTERNAL MODULE: ./components/TextInput/index.ts
var TextInput = __webpack_require__(15516);
// EXTERNAL MODULE: ./components/Checkbox/index.ts + 1 modules
var Checkbox = __webpack_require__(62874);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(46349);
;// CONCATENATED MODULE: ./components/Connects/Connect.tsx


















var Connect = function(param) {
    var aboutData = param.aboutData;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(""), fileName = ref1[0], setFileName = ref1[1];
    var fileInputRef = (0,react.useRef)(null);
    var route = (0,router.useRouter)();
    var id = route.query.id;
    var validationSchema = index_esm/* object */.Ry({
        name: index_esm/* string */.Z_().required("Enter a full name"),
        email: index_esm/* string */.Z_().email("Invalid email").required("Enter an email address like example@mysite.com."),
        phone: index_esm/* string */.Z_().matches(/^[0-9+\-\s()]+$/, "Please enter a valid phone number"),
        company: index_esm/* string */.Z_().max(100, "Company name is too long"),
        message: index_esm/* string */.Z_().required("Enter an answer."),
        privacy: index_esm/* boolean */.O7().oneOf([
            true
        ], "You must agree to the privacy policy.").required("You must agree to the privacy policy.")
    });
    var initialValues = {
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
        file: null,
        privacy: false
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, param) {
            var resetForm, formData, response, error, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        resetForm = param.resetForm;
                        formData = new FormData();
                        formData.append("name", values.name);
                        formData.append("email", values.email);
                        if (values.phone) formData.append("phone", values.phone);
                        if (values.company) formData.append("company", values.company);
                        formData.append("message", values.message);
                        if (values.file) {
                            formData.append("file", values.file);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4,
                            axios/* default.post */.Z.post("".concat("https://api.vxfx.io", "/contacts"), formData)
                        ];
                    case 2:
                        response = _state.sent();
                        dist/* default.success */.ZP.success("Your message has been sent successfully.");
                        // Track form submission for analytics
                        (0,analytics/* trackFormSubmission */.Pv)("contact_form", "/");
                        // Reset form and file state
                        setFileName("");
                        resetForm();
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dist/* default.error */.ZP.error((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Something went wrong. Please try again.");
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleContactClick = function() {
        window.open("/contact-us", "_blank");
    };
    var handleFAQClick = function() {
        window.open("/faq", "_blank");
    };
    (0,react.useEffect)(function() {
        if (id) {
            setTimeout(function() {
                var anchor = document.querySelector("#contact-form");
                if (anchor) {
                    var elementPosition = anchor.getBoundingClientRect().top + window.scrollY;
                    var offsetPosition = elementPosition - 60;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
                route.replace("/", undefined, {
                    shallow: true
                });
            }, 1000);
        }
    }, [
        id,
        route
    ]);
    var handleFileDelete = function(setFieldValue) {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setFileName("");
        setFieldValue("file", null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (connects_module_default()).connectSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (connects_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundCircle/* BackgroundCircle */.K, {
                    top: "13%",
                    left: "30%",
                    width: "400px",
                    height: "400px",
                    animation: "glow",
                    style: {
                        zIndex: 0
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_awesome_reveal_dist/* Fade */.pT, {
                    triggerOnce: true,
                    duration: 800,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (connects_module_default()).leftContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (connects_module_default()).badge,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/connect-badge.svg",
                                    alt: "badge",
                                    width: 352,
                                    height: 88
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                className: (connects_module_default()).subtitle,
                                children: "Interested in our products?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                className: (connects_module_default()).title,
                                children: "Let's discuss your needs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                className: (connects_module_default()).description,
                                children: "Share your requirements, creative workflow, target hosts, and technical constraints. Our team will help you shape them into the right product configuration and chart the clearest path from concept to a production-ready solution."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (connects_module_default()).buttonContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        onClick: handleContactClick,
                                        className: (connects_module_default()).contactButton,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "19",
                                            height: "19",
                                            viewBox: "0 0 19 19",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M10.934 4.16671C11.7479 4.32551 12.496 4.72359 13.0823 5.30999C13.6687 5.89639 14.0668 6.64443 14.2256 7.45837M10.934 0.833374C12.625 1.02124 14.202 1.77852 15.4058 2.98088C16.6097 4.18324 17.369 5.75922 17.559 7.45004M7.74811 10.7193C6.7468 9.71795 5.95614 8.58575 5.37614 7.37773C5.32625 7.27382 5.30131 7.22187 5.28214 7.15613C5.21404 6.9225 5.26296 6.63562 5.40464 6.43776C5.4445 6.38208 5.49213 6.33445 5.58739 6.23919C5.87873 5.94785 6.0244 5.80218 6.11964 5.6557C6.4788 5.10329 6.4788 4.39114 6.11964 3.83873C6.0244 3.69225 5.87873 3.54658 5.58739 3.25524L5.425 3.09285C4.98213 2.64998 4.7607 2.42855 4.52288 2.30826C4.04991 2.06904 3.49136 2.06904 3.01839 2.30826C2.78057 2.42855 2.55914 2.64998 2.11627 3.09285L1.98491 3.22422C1.54356 3.66557 1.32288 3.88624 1.15434 4.18627C0.967324 4.51919 0.832855 5.03627 0.833992 5.41812C0.835015 5.76224 0.901769 5.99743 1.03527 6.4678C1.75275 8.99563 3.10648 11.3809 5.09646 13.3709C7.08644 15.3609 9.47175 16.7146 11.9996 17.4321C12.4699 17.5656 12.7051 17.6324 13.0493 17.6334C13.4311 17.6345 13.9482 17.5001 14.2811 17.313C14.5811 17.1445 14.8018 16.9238 15.2432 16.4825L15.3745 16.3511C15.8174 15.9082 16.0388 15.6868 16.1591 15.449C16.3983 14.976 16.3983 14.4175 16.1591 13.9445C16.0388 13.7067 15.8174 13.4852 15.3745 13.0424L15.2121 12.88C14.9208 12.5886 14.7751 12.443 14.6286 12.3477C14.0762 11.9886 13.3641 11.9886 12.8117 12.3477C12.6652 12.443 12.5195 12.5886 12.2282 12.88C12.1329 12.9752 12.0853 13.0229 12.0296 13.0627C11.8318 13.2044 11.5449 13.2533 11.3112 13.1852C11.2455 13.1661 11.1936 13.1411 11.0896 13.0912C9.88163 12.5112 8.74943 11.7206 7.74811 10.7193Z",
                                                stroke: "#D6BBFB",
                                                strokeWidth: "1.66667",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        iconPosition: "left",
                                        children: "Contact us"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        onClick: handleFAQClick,
                                        className: (connects_module_default()).faqButton,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "17",
                                            height: "19",
                                            viewBox: "0 0 17 19",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5.90896 6.54673C6.10488 5.98979 6.49158 5.52016 7.00058 5.22101C7.50959 4.92187 8.10804 4.81251 8.68994 4.91233C9.27184 5.01214 9.79964 5.31467 10.1799 5.76634C10.5601 6.21801 10.7682 6.78967 10.7673 7.38007C10.7673 9.04673 8.26729 9.88007 8.26729 9.88007M8.33398 13.2134H8.34232M0.833984 5.66461V12.4289C0.833984 12.7144 0.833984 12.8572 0.876055 12.9845C0.913274 13.0972 0.974116 13.2006 1.05451 13.2878C1.14539 13.3864 1.27019 13.4557 1.51979 13.5944L7.68646 17.0203C7.9228 17.1516 8.04096 17.2173 8.16611 17.243C8.27687 17.2658 8.3911 17.2658 8.50186 17.243C8.627 17.2173 8.74517 17.1516 8.98151 17.0203L15.1482 13.5944C15.3978 13.4557 15.5226 13.3864 15.6135 13.2878C15.6939 13.2006 15.7547 13.0972 15.7919 12.9845C15.834 12.8572 15.834 12.7144 15.834 12.4289V5.66461C15.834 5.37908 15.834 5.23631 15.7919 5.10898C15.7547 4.99633 15.6939 4.89293 15.6135 4.80569C15.5226 4.70707 15.3978 4.63774 15.1482 4.49907L8.98151 1.07314C8.74517 0.941845 8.627 0.876196 8.50186 0.850459C8.3911 0.827679 8.27687 0.827679 8.16611 0.850459C8.04096 0.876196 7.9228 0.941845 7.68646 1.07314L1.51979 4.49907C1.27019 4.63774 1.14539 4.70707 1.05451 4.80569C0.974116 4.89293 0.913274 4.99633 0.876055 5.10898C0.833984 5.23631 0.833984 5.37908 0.833984 5.66461Z",
                                                stroke: "#D6BBFB",
                                                strokeWidth: "1.66667",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        iconPosition: "left",
                                        children: "Read FAQ"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_awesome_reveal_dist/* Fade */.pT, {
                    triggerOnce: true,
                    duration: 800,
                    delay: 200,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (connects_module_default()).rightContent,
                        id: "contact-form",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (connects_module_default()).formContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                initialValues: initialValues,
                                validationSchema: validationSchema,
                                onSubmit: handleSubmit,
                                validateOnChange: true,
                                validateOnBlur: true,
                                children: function(param) {
                                    var errors = param.errors, touched = param.touched, setFieldValue = param.setFieldValue, values = param.values, setFieldTouched = param.setFieldTouched;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                        className: (connects_module_default()).form,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRowFullWidth,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    id: "name",
                                                    name: "name",
                                                    type: "text",
                                                    label: "Full name",
                                                    placeholder: "Enter your full name",
                                                    fullWidth: true,
                                                    required: true,
                                                    value: values.name,
                                                    onChange: function(e) {
                                                        return setFieldValue("name", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("name", true);
                                                    },
                                                    error: touched.name && errors.name ? errors.name : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRowFullWidth,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    id: "email",
                                                    name: "email",
                                                    type: "email",
                                                    label: "Email",
                                                    placeholder: "Enter your email",
                                                    fullWidth: true,
                                                    required: true,
                                                    value: values.email,
                                                    onChange: function(e) {
                                                        return setFieldValue("email", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("email", true);
                                                    },
                                                    inputType: "email",
                                                    error: touched.email && errors.email ? errors.email : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRowFullWidth,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    id: "phone",
                                                    name: "phone",
                                                    type: "tel",
                                                    label: "Phone number",
                                                    placeholder: "Enter your phone number",
                                                    fullWidth: true,
                                                    inputType: "phone",
                                                    value: values.phone,
                                                    onChange: function(e) {
                                                        return setFieldValue("phone", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("phone", true);
                                                    },
                                                    error: touched.phone && errors.phone ? errors.phone : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRowFullWidth,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    id: "company",
                                                    name: "company",
                                                    type: "text",
                                                    label: "Company name",
                                                    placeholder: "Enter your company name",
                                                    fullWidth: true,
                                                    value: values.company,
                                                    onChange: function(e) {
                                                        return setFieldValue("company", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("company", true);
                                                    },
                                                    error: touched.company && errors.company ? errors.company : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRowFullWidth,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    id: "message",
                                                    name: "message",
                                                    label: "Message",
                                                    placeholder: "Leave us a message...",
                                                    fullWidth: true,
                                                    required: true,
                                                    multiline: true,
                                                    rows: 4,
                                                    value: values.message,
                                                    onChange: function(e) {
                                                        return setFieldValue("message", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("message", true);
                                                    },
                                                    error: touched.message && errors.message ? errors.message : undefined
                                                })
                                            }),
                                            fileName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (connects_module_default()).fileContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (connects_module_default()).fileInfo,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (connects_module_default()).fileLabel,
                                                                children: "Attached file:"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (connects_module_default()).fileName,
                                                                title: fileName,
                                                                children: fileName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handleFileDelete(setFieldValue);
                                                        },
                                                        "aria-label": "Remove ".concat(fileName),
                                                        className: (connects_module_default()).deleteBtn,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/deleteicon.png",
                                                            alt: "Delete file",
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (connects_module_default()).formRow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                                    id: "privacy",
                                                    name: "privacy",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "You agree to our friendly",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                variant: "text-md",
                                                                as: "span",
                                                                color: "brand-500",
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    return window.open("/privacy-policy", "_blank");
                                                                },
                                                                children: "privacy policy"
                                                            })
                                                        ]
                                                    }),
                                                    required: true,
                                                    checked: values.privacy,
                                                    onChange: function(checked) {
                                                        return setFieldValue("privacy", checked);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("privacy", true);
                                                    },
                                                    error: touched.privacy && errors.privacy ? errors.privacy : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (connects_module_default()).buttonRow,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        type: "submit",
                                                        fullWidth: true,
                                                        disabled: loading,
                                                        label: loading ? "Sending..." : "Send message"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        type: "button",
                                                        variant: "secondary",
                                                        fullWidth: true,
                                                        onClick: function() {
                                                            var ref;
                                                            (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                                        },
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M8 12L8 4M4 8L8 4L12 8",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }),
                                                        iconPosition: "right",
                                                        label: "Upload File"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "file",
                                                        accept: "image/*, application/pdf, .doc, .docx",
                                                        className: (connects_module_default()).filess,
                                                        ref: fileInputRef,
                                                        onChange: function(e) {
                                                            if (e.currentTarget.files) {
                                                                var ref;
                                                                setFileName(((ref = e.currentTarget.files[0]) === null || ref === void 0 ? void 0 : ref.name) || "");
                                                                setFieldValue("file", e.currentTarget.files[0]);
                                                            }
                                                        },
                                                        style: {
                                                            display: "none"
                                                        },
                                                        "aria-label": "File input"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Connects_Connect = (Connect);

// EXTERNAL MODULE: ./components/StructuredData/index.ts + 6 modules
var StructuredData = __webpack_require__(55306);
// EXTERNAL MODULE: ./components/SEO/index.ts + 1 modules
var SEO = __webpack_require__(38743);
;// CONCATENATED MODULE: ./pages/index.tsx






// Lazy load heavy components for better code splitting
var Books = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5883).then(__webpack_require__.bind(__webpack_require__, 55883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55883)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                minHeight: "400px"
            }
        });
    }
});
var SimpleSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9585), __webpack_require__.e(8780)]).then(__webpack_require__.bind(__webpack_require__, 38780));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38780)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                minHeight: "200px"
            }
        });
    }
});
var VideoSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9585), __webpack_require__.e(2624)]).then(__webpack_require__.bind(__webpack_require__, 12624));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12624)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                minHeight: "500px"
            }
        });
    }
});
var BlogSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5119), __webpack_require__.e(9201), __webpack_require__.e(1166), __webpack_require__.e(3091)]).then(__webpack_require__.bind(__webpack_require__, 35283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35283)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                minHeight: "300px"
            }
        });
    }
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8030), __webpack_require__.e(6309), __webpack_require__.e(9495)]).then(__webpack_require__.bind(__webpack_require__, 83767));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83767)
            ];
        }
    }
});
var Home = function(param) {
    var pageData = param.pageData, products = param.products, aboutData = param.aboutData, blogPosts = param.blogPosts;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "containerAnimationMain",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Universal Video Plugin Framework | Cross-Platform",
                description: "Universal video plugin framework supporting Windows, macOS, and Linux. Compatible with Adobe Premiere Pro, DaVinci Resolve, Final Cut Pro, Sony Vegas Pro, Nuke, Natron, OFX, OpenFX hosts. GPU-accelerated with CUDA, OpenCL, Metal, and DirectX technologies. Professional VFX and video editing solutions with 25+ years expertise.",
                keywords: "video plugin, adobe premiere, davinci resolve, video editing, plugin development"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData/* OrganizationSchema */.od, {
                email: aboutData === null || aboutData === void 0 ? void 0 : (ref = aboutData[0]) === null || ref === void 0 ? void 0 : ref.email,
                phone: aboutData === null || aboutData === void 0 ? void 0 : (ref1 = aboutData[0]) === null || ref1 === void 0 ? void 0 : ref1.phone,
                address: (aboutData === null || aboutData === void 0 ? void 0 : (ref2 = aboutData[0]) === null || ref2 === void 0 ? void 0 : ref2.address) ? {
                    streetAddress: aboutData[0].address
                } : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData/* SoftwareApplicationSchema */.uA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {
                data: pageData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Books, {
                products: products
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection, {
                data: {
                    components: [
                        {
                            name: "msg_section",
                            mainHeading: "Powering Creativity with Performance",
                            subHeading: "Epen empowers creators with innovative video editing solutions, cross-platform technologies, and GPU-accelerated tools. Backed by specialists with over 25 years of experience, our flagship product streamlines complex editing tasks through advanced graphic programming and algorithm design—helping creators and businesses edit faster and smarter."
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Connects_Connect, {
                aboutData: aboutData
            }),
            blogPosts && blogPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogSection, {
                posts: blogPosts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                aboutData: aboutData
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 15450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backgroundCircle":"BackgroundCircle_backgroundCircle__Xwq5y","desktopCircle":"BackgroundCircle_desktopCircle__uDSgn","tabletCircle":"BackgroundCircle_tabletCircle__iAedP","mobileCircle":"BackgroundCircle_mobileCircle__gKLBI","animation-float":"BackgroundCircle_animation-float__HigCE","float":"BackgroundCircle_float__YvZ6x","animation-pulse":"BackgroundCircle_animation-pulse__HzajN","pulse":"BackgroundCircle_pulse__474uS","animation-glow":"BackgroundCircle_animation-glow__kn4ID","glow":"BackgroundCircle_glow__rUtVJ"};

/***/ }),

/***/ 46641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__RNxPR","checkbox":"Checkbox_checkbox__exCc_","input":"Checkbox_input__nTZmL","checkboxBox":"Checkbox_checkboxBox__3vjaW","checkmark":"Checkbox_checkmark__BbcGW","label":"Checkbox_label__CbFqD","labelDisabled":"Checkbox_labelDisabled__QcFT8","labelError":"Checkbox_labelError__XD_a2","errorMessage":"Checkbox_errorMessage__tkOB6","size-sm":"Checkbox_size-sm__OKlpz","size-md":"Checkbox_size-md__2lRHw","size-lg":"Checkbox_size-lg__9tJW9","error":"Checkbox_error__ZlNjE","focused":"Checkbox_focused__R2964","color-primary":"Checkbox_color-primary__jn2Zo","color-secondary":"Checkbox_color-secondary__Eea0a","color-success":"Checkbox_color-success__pBbJr","color-warning":"Checkbox_color-warning__sjauP","color-error":"Checkbox_color-error__WB01Q","checked":"Checkbox_checked__lkDil","disabled":"Checkbox_disabled__dTK4V"};

/***/ }),

/***/ 99481:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"connectSection":"connects_connectSection__YwOvr","container":"connects_container__sNRdd","leftContent":"connects_leftContent__usnpa","badge":"connects_badge__VxZQq","subtitle":"connects_subtitle__hGhWk","title":"connects_title__AEF4M","description":"connects_description__S68uU","buttonContainer":"connects_buttonContainer__Vcukt","rightContent":"connects_rightContent__Ru9XE","formContainer":"connects_formContainer__naXiV","form":"connects_form__Z9RVX","formRow":"connects_formRow__vCMxE","formRowFullWidth":"connects_formRowFullWidth__e3w76","buttonRow":"connects_buttonRow__T97_W","fileContainer":"connects_fileContainer__LdeCL","fileInfo":"connects_fileInfo__6qRWq","fileLabel":"connects_fileLabel__EW3SL","fileName":"connects_fileName__VXHcD","deleteBtn":"connects_deleteBtn__c5m5p","attachBtn":"connects_attachBtn__OeWMy"};

/***/ }),

/***/ 55716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77585)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3053,3977,6538,6607,6399,5413,2033,5304,5166,1407,9774,2888,179], function() { return __webpack_exec__(39851); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);